import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = { class: "page-header__top" }
const _hoisted_3 = { class: "page-header__container m-auto d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "page-header__contact" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "page-header__locale" }
const _hoisted_8 = { class: "page-header__bottom" }
const _hoisted_9 = { class: "page-header__container m-auto d-flex align-items-center justify-content-between" }
const _hoisted_10 = { class: "page-header__nav d-inline-flex align-items-center" }
const _hoisted_11 = { class: "page-header__actions d-inline-flex align-items-center" }
const _hoisted_12 = ["data-text-alt"]
const _hoisted_13 = ["data-text-alt"]

import useLocale from '@/util/locale';
import Icon from '@/components/_shared/Icon/Icon.vue';
import Logo from '@/components/_shared/Logo/Logo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  emits: ['onShowModal'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const { VUE_APP_CONTACT_SALES_EMAIL, VUE_APP_CONTACT_PHONE } = process.env;
const { onSwitch, selectedLocaleId } = useLocale();

const onChangeLocale = () => {
	onSwitch();
};

const onShowModal = (modal: string) => {
	emits('onShowModal', modal);
};

const openStore = () => {
	const baseUrl = 'https://store.disty.app';
	const url = selectedLocaleId.value === 'en' ? `${baseUrl}/en` : `${baseUrl}/ar`;
	window.open(url, '_blank');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: `mailto:${_unref(VUE_APP_CONTACT_SALES_EMAIL)}`,
            target: "__blank",
            class: "page-header__contact-email"
          }, _toDisplayString(_unref(VUE_APP_CONTACT_SALES_EMAIL)), 9, _hoisted_5),
          _createElementVNode("a", {
            href: `tel:${_unref(VUE_APP_CONTACT_PHONE)}`,
            target: "__blank",
            class: "page-header__contact-phone"
          }, [
            _createVNode(Icon, { icon: "phone" }),
            _createTextVNode(" " + _toDisplayString(_unref(VUE_APP_CONTACT_PHONE)), 1)
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: "#",
            class: "page-header__contact-phone",
            onClick: _withModifiers(onChangeLocale, ["prevent"])
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('header.locale')) + " ", 1),
            _createVNode(Icon, { icon: "locale" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: "m-0 p-0",
            to: `/${_unref(selectedLocaleId)}`
          }, {
            default: _withCtx(() => [
              _createVNode(Logo, { place: "header" })
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: `/${_unref(selectedLocaleId)}#vendor`,
            "data-text-alt": _ctx.$t('header.vendor')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.vendor')), 1)
            ]),
            _: 1
          }, 8, ["to", "data-text-alt"]),
          _createVNode(_component_router_link, {
            to: `/${_unref(selectedLocaleId)}#wholesaler`,
            "data-text-alt": _ctx.$t('header.wholesaler')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.wholesaler')), 1)
            ]),
            _: 1
          }, 8, ["to", "data-text-alt"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "outline btn-flip",
            "data-text-alt": _ctx.$t('header.joinAsAsupplierManufacturer'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onShowModal('supplier')))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.joinAsAsupplierManufacturer')), 1)
          ], 8, _hoisted_12),
          _createElementVNode("button", {
            class: "secondary btn-flip",
            "data-text-alt": _ctx.$t('header.customerPortalStore'),
            onClick: openStore
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('header.customerPortalStore')), 1)
          ], 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}
}

})